const initialState=[]
export const FriendsReducer = (state = initialState,action)=>{
    switch(action.type){
        case 'UPDATE_FRIENDS':
            return action.payload
        default:
            return state
    }
}